module.exports = __webpack_public_path__ + "img/reset-password.ccc63d4d.png";